'use strict';

var ConfigClone = require('actionGroups/configClone/ConfigClone');
var ConfigCloneView = require('actionGroups/configClone/ConfigCloneView');

module.exports = {
  Model: ConfigClone,
  GroupView: ConfigCloneView,
};
